import _extends from "@babel/runtime/helpers/extends";
import { Box, Heading, Text } from '@wix/design-system';
import React from 'react';
import { Groups, LockLocked, WixForum } from '@wix/wix-ui-icons-common/lazy';
import { HeaderWrapper } from '../HeaderWrapper';
import s from './AnonymousResultsHeader.scss';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { AnonymousVoucherBanner } from '../../VoucherBanner';
const TrustBuilderItem = _ref => {
  let {
    icon,
    text
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    verticalAlign: "middle"
  }, icon, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal"
  }, text));
};
export const BngResultsHeader = _ref2 => {
  let {
    onBackClick,
    ...props
  } = _ref2;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const isMobile = useIsMobile();
  const title = /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.resultsHeaderTitle
  }, t('domain_search_gate.bng_results.title'));
  if (isMobile) {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      width: "100%"
    }, /*#__PURE__*/React.createElement(AnonymousVoucherBanner, null), /*#__PURE__*/React.createElement(Box, {
      paddingTop: "SP3"
    }, /*#__PURE__*/React.createElement(HeaderWrapper, props, title)));
  }
  const trustBuilders = [{
    icon: /*#__PURE__*/React.createElement(Groups, {
      size: "18px"
    }),
    translationKey: 'domains_search_gate.storefront_results.optimized.trust_builder.millions'
  }, {
    icon: /*#__PURE__*/React.createElement(LockLocked, {
      size: "18px"
    }),
    translationKey: 'domain_search_gate.storefront_results.trust_builder.ssl'
  }, {
    icon: /*#__PURE__*/React.createElement(WixForum, {
      size: "18px"
    }),
    translationKey: 'domains_search_gate.storefront_results.optimized.trust_builder.support'
  }];
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    gap: "SP3",
    marginBottom: "SP1"
  }, /*#__PURE__*/React.createElement(Box, {
    paddingBottom: "SP3"
  }, /*#__PURE__*/React.createElement(AnonymousVoucherBanner, null)), /*#__PURE__*/React.createElement(HeaderWrapper, _extends({
    onBackClick: onBackClick
  }, props), title), /*#__PURE__*/React.createElement(Box, {
    gap: "SP6",
    align: "center",
    verticalAlign: "middle",
    className: s.whyWixBenefits
  }, trustBuilders.map(_ref3 => {
    let {
      icon,
      translationKey
    } = _ref3;
    return /*#__PURE__*/React.createElement(TrustBuilderItem, {
      key: translationKey,
      icon: icon,
      text: t(translationKey)
    });
  })));
};
//# sourceMappingURL=BngResultsHeader.js.map